/**
 * This function uses document.currentScript to set the __webpack_public_path__ for webpack to figure out
 * where to load the other chunks. It should be called only once per experience/app.
 * Note: document.currentScript is not supported in IE, so do not use this function if IE support is required.
 */
export function setCurrentScriptHostAsCdnDomain() {
    var currentScript = document.currentScript;
    if (currentScript) {
        var url = currentScript.src;
        var baseUrl = url.substring(0, url.lastIndexOf('/') + 1);
        setCdnDomain(baseUrl);
    }
}
export function setCdnDomain(cdnDomain) {
    __webpack_public_path__ = cdnDomain;
}
//# sourceMappingURL=setCdnDomain.js.map